// Auralore — reveal on scroll + tiny UI wiring
(function () {
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
  document.querySelectorAll('.reveal').forEach(function (el, i) { el.style.setProperty('--d', (i % 4) * 70 + 'ms'); io.observe(el); });

  document.querySelectorAll('[data-accordion] > .acc__item > button').forEach(function (b) {
    b.addEventListener('click', function () {
      var item = b.parentElement, open = item.classList.contains('is-open');
      item.parentElement.querySelectorAll('.acc__item').forEach(function (i) { i.classList.remove('is-open'); });
      if (!open) item.classList.add('is-open');
    });
  });

  var toggle = document.querySelector('[data-nav-toggle]');
  var drawer = document.getElementById('nav-drawer');
  var scrim = document.querySelector('.drawer__scrim');
  function setNav(open) {
    if (!drawer) return;
    document.body.classList.toggle('nav-open', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (scrim) { if (open) { scrim.removeAttribute('hidden'); } else { scrim.setAttribute('hidden', ''); } }
  }
  if (toggle) toggle.addEventListener('click', function () { setNav(!document.body.classList.contains('nav-open')); });
  document.querySelectorAll('[data-nav-close]').forEach(function (el) { el.addEventListener('click', function () { setNav(false); }); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setNav(false); });
})();
